import { render, staticRenderFns } from "./select-vip-lv.vue?vue&type=template&id=4e1b7680"
import script from "./select-vip-lv.vue?vue&type=script&lang=ts"
export * from "./select-vip-lv.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports